import { render, staticRenderFns } from "./reportcount.vue?vue&type=template&id=6bcf9be1&scoped=true&"
import script from "./reportcount.vue?vue&type=script&lang=js&"
export * from "./reportcount.vue?vue&type=script&lang=js&"
import style0 from "./reportcount.vue?vue&type=style&index=0&id=6bcf9be1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf9be1",
  null
  
)

export default component.exports